import { Alert } from '@zooplus/ui-components';

import styles from '../Banners/Banner.module.scss';

interface ErrorAlertProps {
  errorMessage: string | null | undefined;
}

/**
 * Basic component to display a warning message.
 */
const ErrorAlert: React.FC<ErrorAlertProps> = ({ errorMessage }) => {
  return errorMessage ? (
    <Alert variant="warning" data-zta="errorCreditCard" className={styles.alertWrapper}>
      {errorMessage}
    </Alert>
  ) : null;
};

export default ErrorAlert;
